export const householdSpendingsQuestions: Record<string, any> = {
  essentialSpending: {
    labelKey: 'applicationForm.HOUSEHOLD_SPENDINGS.essentialSpending.label',
    explanationKey: 'applicationForm.HOUSEHOLD_SPENDINGS.essentialSpending.explanation',
  },
  lifestyleSpending: {
    labelKey: 'applicationForm.HOUSEHOLD_SPENDINGS.lifestyleSpending.label',
    explanationKey: 'applicationForm.HOUSEHOLD_SPENDINGS.lifestyleSpending.explanation',
  },
};
